<template>
    <nav class="app-tabbar">
        <div
            class="tab-item"
            v-for="item in tabs"
            :key="item.key"
            :class="{ on: item.key === currentKey }"
            @click="handleGo(item)"
        >
            <span class="tab-ico" v-html="item.icon"></span>
            <span class="tab-txt">{{ item.text }}</span>
            <i class="tab-dot" v-if="item.dot && item.key !== currentKey"></i>
        </div>
    </nav>
</template>

<script>
/**
 * H5 底部菜单。
 *
 * 说明：
 *  - 图标全部内联 SVG，用 currentColor 上色，所以选中态直接跟随 --blueTheme 主题变量。
 *  - 高度按 750 稿写（postcss-pxtorem rootValue=75），实际约 50px + 安全区。
 *  - 通过 meta.tabbar = true 的页面在 App.vue 里统一挂载。
 */

const ICONS = {
    home:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M3.2 10.6 12 3.4l8.8 7.2"/><path d="M5.6 9.4V20.2h12.8V9.4"/><path d="M9.6 20.2v-5.6h4.8v5.6"/></svg>',
    study:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M12 6.6C10.5 5.3 8.3 4.7 4.4 4.9v12.9c3.9-.2 6.1.4 7.6 1.7 1.5-1.3 3.7-1.9 7.6-1.7V4.9c-3.9-.2-6.1.4-7.6 1.7Z"/>' +
        '<path d="M12 6.6v12.9"/></svg>',
    hwk:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<rect x="4.4" y="3.4" width="15.2" height="17.2" rx="2.6"/><path d="M8.4 8.4h7.2M8.4 12.2h7.2M8.4 16h4.2"/></svg>',
    mine:
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="12" cy="8.2" r="3.7"/><path d="M4.6 20.3c.9-3.8 3.9-5.9 7.4-5.9s6.5 2.1 7.4 5.9"/></svg>'
};

export default {
    name: 'AppTabBar',
    props: {
        /** 显式指定当前项，留空则按路由自动判定 */
        active: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tabs: [
                { key: 'home', text: '首页', path: '/home', icon: ICONS.home, match: ['/home'] },
                {
                    key: 'study',
                    text: '学习',
                    path: '/examhome',
                    icon: ICONS.study,
                    // 成绩曲线、错题本都属于「学习」这一路，进来时菜单高亮在学习上
                    match: ['/examhome', '/exam', '/score', '/wrong']
                },
                {
                    key: 'hwk',
                    text: '作业',
                    path: '/hwk/home',
                    icon: ICONS.hwk,
                    // /hwk 下的明细页也算「作业」，/forzl 信箱已从菜单移出（仍可通过「我的」进入）
                    match: ['/hwk']
                },
                { key: 'mine', text: '我的', path: '/mine', icon: ICONS.mine, match: ['/mine'] }
            ]
        };
    },
    computed: {
        currentKey() {
            if (this.active) {
                return this.active;
            }
            const path = (this.$route && this.$route.path) || '';
            const hit = this.tabs.filter(t =>
                t.match.some(m => path === m || path.indexOf(m) === 0)
            );
            return hit.length ? hit[0].key : '';
        }
    },
    methods: {
        handleGo(item) {
            if (item.key === this.currentKey) {
                return;
            }
            this.$router.push({ path: item.path });
        }
    }
};
</script>

<style lang="less" scoped>
.app-tabbar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 300;
    display: flex;
    height: 100px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background: rgba(255, 255, 255, 0.96);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 -6px 24px rgba(15, 39, 76, 0.06);

    .tab-item {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #98a1b0;
        transition: color 0.2s ease;

        &.on {
            color: var(--blueTheme, #0066b3);
        }
        &:active {
            opacity: 0.7;
        }
    }

    .tab-ico {
        width: 46px;
        height: 46px;
        margin-bottom: 6px;

        svg {
            display: block;
            width: 100%;
            height: 100%;
        }
    }

    .tab-txt {
        font-size: 22px;
        line-height: 1;
        letter-spacing: 1px;
    }

    .tab-dot {
        position: absolute;
        top: 18px;
        left: 50%;
        margin-left: 10px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #f5222d;
    }
}
</style>
